import { CatalogSearchResults } from '~/features/catalog/models/catalog-search-result';

export function createCatalogStructuredData(catalogSearchResults: CatalogSearchResults) {
  const searchResultItems = catalogSearchResults?.searchResultItems ?? [];
  return {
    '@context': 'http://schema.org',
    '@type': 'ItemList',
    itemListElement: searchResultItems.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      url: `https://www.udacity.com/course/${item.slug}`,
    })),
  };
}
